import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Palette, Check, ChevronDown } from 'lucide-react';
import { clsx } from 'clsx';

export const ThemeSelector: React.FC = () => {
  const { currentTheme, themes, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const themeList = Object.values(themes);

  return (
    <div className="px-4 py-2">
      {/* Theme Header Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors hover:bg-opacity-10"
        style={{ color: currentTheme.colors.text.primary }}
      >
        <div className="flex items-center space-x-2">
          <Palette className="h-4 w-4" style={{ color: currentTheme.colors.text.secondary }} />
          <span className="font-medium">Themes</span>
        </div>
        <div className="flex items-center space-x-2">
          <div 
            className="w-4 h-4 rounded-full border-2 border-white shadow-sm"
            style={{ backgroundColor: currentTheme.colors.primary[500] }}
          />
          <ChevronDown 
            className={clsx("h-4 w-4 transition-transform", isOpen && "rotate-180")}
            style={{ color: currentTheme.colors.text.secondary }}
          />
        </div>
      </button>

      {/* Theme Options Dropdown */}
      {isOpen && (
        <div className="mt-2 space-y-1 pl-6">
          {themeList.map((theme) => (
            <button
              key={theme.id}
              onClick={() => {
                setTheme(theme.id);
                setIsOpen(false);
              }}
              className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors hover:bg-opacity-10"
              style={{
                backgroundColor: currentTheme.id === theme.id ? currentTheme.colors.primary[100] : 'transparent',
                color: currentTheme.id === theme.id ? currentTheme.colors.primary[700] : currentTheme.colors.text.secondary,
              }}
            >
              <div className="flex items-center space-x-3">
                <div 
                  className="w-3 h-3 rounded-full border border-white shadow-sm"
                  style={{ backgroundColor: theme.colors.primary[500] }}
                />
                <span>{theme.name}</span>
              </div>
              {currentTheme.id === theme.id && (
                <Check className="h-3 w-3" style={{ color: currentTheme.colors.primary[700] }} />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};